export default {
  name: 'footerbar',
  components: {}
}